export const FAILED = 'Transactions/failed';
export const LOADING = 'Transactions/loading';
export const SUCCESS = 'Transactions/success';
export const SET_DATA = 'Transactions/set_data';
